import { motion } from "framer-motion";
import { ArrowDown } from "@phosphor-icons/react";

const BOOK_COVER = "https://customer-assets.emergentagent.com/job_written-by-logart/artifacts/pdoqlfcv_Front%20Cover%20ENG.jpg";

export default function HeroSection({ onNavigate }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ paddingTop: "5rem" }}
    >
      {/* Subtle background glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 70% 50%, rgba(234,208,161,0.04) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Text content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="order-2 lg:order-1"
          >
            <p
              className="text-sm tracking-widest uppercase mb-6"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 400,
                color: "var(--text-secondary)",
                letterSpacing: "0.15em",
              }}
            >
              A Children's Story by Ulrika Logart
            </p>

            <h1
              className="text-4xl sm:text-5xl lg:text-6xl leading-tight mb-6"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 400,
                color: "var(--text-primary)",
                lineHeight: 1.15,
              }}
            >
              The Disco
              <br />
              <span style={{ color: "var(--gold)" }}>Whale</span>
            </h1>

            <div className="gold-divider mb-8" />

            <p
              className="text-base md:text-lg mb-10 max-w-md leading-relaxed"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 300,
                color: "var(--text-secondary)",
                lineHeight: 1.75,
              }}
            >
              A heartwarming tale about empathy, kindness, and the beauty of
              unexpected friendship — for toddlers & young children.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://www.amazon.se/s?i=stripbooks&rh=p_27%3AUlrika%2BLogart&language=en&ref=dp_byline_sr_book_1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold"
                data-testid="hero-amazon-link"
              >
                Order on Amazon
              </a>
              <button
                onClick={() => onNavigate("book")}
                className="btn-outline"
                data-testid="hero-read-more-btn"
              >
                Read More
              </button>
            </div>
          </motion.div>

          {/* Right: Book cover */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.4, ease: "easeOut" }}
            className="order-1 lg:order-2 flex justify-center"
          >
            <div className="relative">
              {/* Glow behind book */}
              <div
                className="absolute -inset-8 rounded-full blur-3xl opacity-20"
                style={{ background: "rgba(234,208,161,0.15)" }}
              />
              <img
                src={BOOK_COVER}
                alt="The Disco Whale - Book Cover"
                data-testid="hero-book-cover"
                className="relative z-10 w-64 sm:w-72 md:w-80 lg:w-96 rounded-sm"
                style={{
                  boxShadow: "0 24px 80px rgba(0,0,0,0.5), 0 4px 20px rgba(0,0,0,0.3)",
                }}
              />
            </div>
          </motion.div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden lg:flex flex-col items-center gap-2 cursor-pointer"
          onClick={() => onNavigate("book")}
          data-testid="scroll-indicator"
        >
          <span
            className="text-xs tracking-widest uppercase"
            style={{
              fontFamily: "'Outfit', sans-serif",
              color: "var(--text-secondary)",
              letterSpacing: "0.15em",
            }}
          >
            Discover
          </span>
          <motion.div
            animate={{ y: [0, 6, 0] }}
            transition={{ repeat: Infinity, duration: 1.8 }}
          >
            <ArrowDown size={18} style={{ color: "var(--gold)" }} />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
